import { registerLocaleData } from '@angular/common';
import localeDeCh from '@angular/common/locales/de-CH';
import localeEnUs from '@angular/common/locales/en';
import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { NullValidationHandler, OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import { selectOidcConfig, selectProgressBar } from '@platform/platform.selectors';
import { ProgressBarState } from '@platform/platform.state';
import * as PlatformActions from '@platform/platform.actions';
import { RootState } from './app.state';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  public title = 'MyObt';
  public progressBar$!: Observable<ProgressBarState>;

  constructor(
    private oauthService: OAuthService,
    private store$: Store<RootState>,
  ) {
    registerLocaleData(localeDeCh, 'de-CH');
    registerLocaleData(localeEnUs, 'en-US');

    this.store$
      .pipe(
        select(selectOidcConfig),
        // we use first to target only a specific state and close the subscription afterwards
        first((authConfig) => !!authConfig),
      )
      .subscribe((authConfig) => {
        this.oauthService.configure(authConfig!);
        this.oauthService.setStorage(localStorage);
        this.oauthService.tokenValidationHandler = new NullValidationHandler();
        this.oauthService.requestAccessToken = false;
        this.oauthService.silentRefreshRedirectUri = window.location.origin + '/silent-refresh.html';
        this.oauthService.setupAutomaticSilentRefresh();

        // if the id claims are already there because we are still logged in -> dispatch action to set the claims in the store
        const identityClaims = this.oauthService.getIdentityClaims();
        if (identityClaims) {
          this.store$.dispatch(PlatformActions.setIdentityClaims({ identityClaims }));
        }
      });
  }
  ngOnInit(): void {
    this.progressBar$ = this.store$.pipe(select(selectProgressBar));
  }
}
